import { format, parse } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

export const formatCreateLogDate = (selectedDate: string, timeStamp: string): string =>
    formatInTimeZone(
        parse(`${format(selectedDate, 'yyyy-MM-dd')} ${timeStamp}`, 'yyyy-MM-dd HH:mm', new Date()),
        'UTC',
        "yyyy-MM-dd'T'HH:mm:ss'Z'"
    )
